import { AuthService } from "./auth.service.js";
import { login } from "./login/login.module";
import { register } from "./register/register.module";
import { changePassword } from "./change-password/change-password.module";
import { resetPassword } from "./reset-password/reset-password.module";

export const auth = angular
  .module("auth", [login, register, changePassword, resetPassword])
  .service("AuthService", AuthService)
  .run(($transitions, $state, AuthService) => {
    "ngInject";
    $transitions.onStart(
      {
        to: "login",
      },
      (state) => {
        if (AuthService.isAuthenticated()) {
          $state.go("home");
          return true;
        }
      }
    );
  }).name;



// WEBPACK FOOTER //
// ./src/app/components/auth/auth.module.js